/**
 * Locked brand tokens — approved via theme-preview-mock.jpg (2026-07).
 *
 * Live product: light theme only.
 * - Center circular plate holds the seal (no second “top emblem” wordmark on home).
 * - Light mode → light/white plate + logo-light.png
 * - Dark mode assets exist for preview only; not used in the app chrome.
 */

export const LOGO_ALT = "Virtuous Trade & Consulting";

/**
 * Browser extension product name (Chrome / Edge / Chromium).
 * Store listing and toolbar title: Virtuous Connect.
 */
export const EXTENSION_NAME = "Virtuous Connect";

/** Light plate seal (primary — live app). */
export const LOGO_SRC = "/logo-light.png";

/** Dark plate seal (preview / future dark theme only). */
export const LOGO_SRC_DARK = "/logo-dark.png";

/** Approved side-by-side mock (locked reference). */
export const THEME_PREVIEW_MOCK = "/theme-preview-mock.jpg";

export const LOGO_PLATE = {
  light: "#ffffff",
  /** Navy plate matching approved dark-mode mock */
  dark: "#0c2340",
} as const;

/** Logo navy (seal / dark plate). Buttons use black/white — see globals.css --accent. */
export const BRAND_NAVY = "#0c2340";

export const TAGLINE = "Opening doors for honest people and businesses.";
